export const RecipientsTableHeader = () => {
  return (
    <div className="cds--structured-list-thead">
      <div className="cds--structured-list-row cds--structured-list-row--header-row">
        {/* <div className="cds--structured-list-th font-ctm--semibold">
            ##
          </div> */}

        <div className="cds--structured-list-th">Id</div>

        <div className="cds--structured-list-th">Alias</div>

        <div className="cds--structured-list-th font-ctm--semibold">
          Acc Name
        </div>

        <div className="cds--structured-list-th font-ctm--semibold">Acc No</div>

        <div className="cds--structured-list-th font-ctm--semibold ">Bank</div>

        <div className="cds--structured-list-th">
          <span className="font-ctm--bold">Action</span>
        </div>
      </div>
    </div>
  );
};
